'use client';

import type { ReactNode } from 'react';

import { RawIntlProvider } from 'react-intl';

import type { LocaleT } from '../../config/locale';

import createIntlShape from '../../utils/intl';

type IntlProviderProps = {
  locale: LocaleT;
  children: ReactNode;
  compiled?: boolean;
};

export default function IntlByLocaleProvider({ locale, children, compiled }: IntlProviderProps) {
  const intlShape = createIntlShape(locale, compiled ?? true);

  return <RawIntlProvider value={intlShape}>{children}</RawIntlProvider>;
}
